/**
 * Control-referenties zoals een auditor ze schrijft ↔ controls van een audit.
 *   "4.1, 7.5.1, A5.1–A5.4, A8.15-A8.23"
 * "A5.1" en "A.5.1" zijn gelijkwaardig. Een bereik loopt over de controls in de
 * opgegeven (gesorteerde) lijst, dus enkel over wat in de audit-scope zit.
 *
 * Kopie van backend/controlRefs.js — wijzigingen in beide doorvoeren.
 */

const norm = (s) => String(s).toUpperCase().replace(/[\s§]/g, '').replace(/^A\.?/, 'A');

// "A.5.1" → "A5.1" (schrijfwijze van het auditplan)
export const displayId = (s) => String(s).replace(/^A\.(\d)/, 'A$1');

// controls: [{ id, control_id }] in sort_order. → { ids, unknown }
export function parseRefs(text, controls) {
  const idx = new Map(controls.map((c, i) => [norm(c.control_id), i]));
  const ids = new Set();
  const unknown = [];
  for (const raw of String(text || '').split(/[,;\n]+/)) {
    const tok = raw.trim();
    if (!tok) continue;
    const parts = tok.split(/\s*[–—-]\s*/);
    if (parts.length === 2) {
      const a = idx.get(norm(parts[0]));
      const b = idx.get(norm(parts[1]));
      if (a === undefined || b === undefined) { unknown.push(tok); continue; }
      for (let i = Math.min(a, b); i <= Math.max(a, b); i++) ids.add(controls[i].id);
    } else {
      const i = idx.get(norm(tok));
      if (i === undefined) { unknown.push(tok); continue; }
      ids.add(controls[i].id);
    }
  }
  return { ids: [...ids], unknown };
}

// Omgekeerd: geselecteerde ids → "4.1, 4.2, A5.1–A5.4". Opeenvolgende reeksen
// van 3+ controls binnen dezelfde sectie worden een bereik.
export function formatRefs(selectedIds, controls) {
  const sel = new Set(selectedIds.map(Number));
  const out = [];
  let run = [];
  const flush = () => {
    if (run.length >= 3) out.push(`${displayId(run[0].control_id)}–${displayId(run[run.length - 1].control_id)}`);
    else run.forEach(c => out.push(displayId(c.control_id)));
    run = [];
  };
  for (const c of controls) {
    if (sel.has(Number(c.id)) && (run.length === 0 || run[run.length - 1].section === c.section)) {
      run.push(c);
    } else {
      flush();
      if (sel.has(Number(c.id))) run.push(c);
    }
  }
  flush();
  return out.join(', ');
}
